import { DrawerObject } from '../../../../components/drawer/drawer.types';
import { FormBuilderComponent } from '../../../../components/form-builder/form-builder.component';
import { DynamicForm } from '../../../../components/form-builder/form-builder.types';
import { BankDetailsRepository } from '../../../../store/bank-details-state/bank-details-state.repository';

interface getBankDetailsAddDrawerObjectProps {
  store?: BankDetailsRepository;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getBankDetailsAddDrawerObject = ({ store, formObject, toggleVisibility, action }: getBankDetailsAddDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.bankDetails.add.title',
    description: 'settings.bankDetails.add.description',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: formObject,
      },
    },
    actions: [
      {
        label: 'settings.bankDetails.add.add',
        onClick: () => action?.(),
      },
      {
        label: 'settings.bankDetails.add.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
